module.exports = {
	"old": "age",
	"averageweight": "weight",
	"maxheight": "height",
	"averagemuscle": "muscle",
	"asian": "race",
	"female": "gender",
	"minfirmness": "breastfirmness",
	"minheight": "height",
	"young": "age",
	"averagecup": "breastsize",
	"minmuscle": "muscle",
	"minweight": "weight",
	"mincup": "breastsize",
	"averagefirmness": "breastfirmness",
	"idealproportions": "bodyproportions",
	"averageheight": "height",
	"regularproportions": "bodyproportions",
	"maxweight": "weight",
	"maxfirmness": "breastfirmness",
	"maxmuscle": "muscle",
	"child": "age",
	"baby": "age",
	"uncommonproportions": "bodyproportions",
	"caucasian": "race",
	"maxcup": "breastsize",
	"african": "race",
	"male": "gender"
};


//////////////////
// WEBPACK FOOTER
// ./~/makehuman-data/src/json/targets/target-category-data.json
// module id = 150
// module chunks = 0